theme.recentlyViewed = {

    productInfo: {},
    recent: {},
    hasSessionStorage: false,
    hasLocalStorage: false,
    localStorage: [],

    boot: function() {

        console.info('%c[Sureify Recently Viewed] ----- Initialising', 'color: #acdd1e;')
        
        // Check for Session storage
        this.hasSessionStorage = this.isStorageSupported('session')

        // Check for Local storage
        this.hasLocalStorage = this.isStorageSupported('local')
        if (this.hasLocalStorage) {
            theme.recentlyViewed.localStorage = window.localStorage.getItem('sureify-recent');
            if (theme.recentlyViewed.localStorage) {
                theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
            }
        }

        // Set product data
        let isProduct = theme.routes.template.includes('product')
        if (isProduct) {
            
            let handle = theme.productData['handle']
            
            // Check if the current product exists
            if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
                delete theme.recentlyViewed.recent[handle]
            }
            
            // Set the recent product
            theme.recentlyViewed.recent[handle] = theme.productData
            
            // Add to local storage
            if (this.hasLocalStorage) {
                window.localStorage.setItem('sureify-recent', JSON.stringify(theme.recentlyViewed.recent));
            }

        }

        // Setup the recent products
        this.set()

    },

    set: function() {

        if ($.isEmptyObject(theme.recentlyViewed.recent)) {
            console.info('%c[Sureify Recently Viewed] ----- Empty', 'color: #ff3a30;')
            return;
        }

        let promises = [];
        for (let handle in theme.recentlyViewed.recent) {
            if (handle !== 'undefined') {
                promises.push(this.get(handle));
            }
        }
   
        Promise.all(promises).then(function(result) {
            this.store(result);
        }.bind(this), function(error) {
            console.info('%c[Sureify Recently Viewed[] ----- Failed to load', 'color: #ff3a30;')
        });

    },

    get: function(handle) {

        return new Promise(function(resolve, reject) {

            if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
                resolve(theme.recentlyViewed.productInfo[handle]);
            } else {
                jQuery.getJSON('/products/'+ handle +'.js', function(product) {
                    resolve(product);
                })
                    .fail(function() {
                        console.info('%c[Sureify Recently Viewed] ----- Product not found, removing from recents', 'color: #ff3a30;')
                        delete theme.recentlyViewed.recent[handle]
                        window.localStorage.setItem('sureify-recent', JSON.stringify(theme.recentlyViewed.recent));
                    })
            }

        });

    },
    
    store: function(products) {

        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        if (this.hasSessionStorage) {
            sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }

        this.populate()

    },

    populate: function() {

        let template    = $('#recent-viewed-template').html();
        let imageSize   = ($('#recent-viewed-template').data('image-size')) ? $('#recent-viewed-template').data('image-size') : '480x480'

        // How many do we have?
        let productCount    = Object.keys(theme.recentlyViewed.recent).length
        let windowWidth     = $(window).width()
        let productsRequiredForCarousel = 1;

        if (windowWidth < 768) {
            imageSize = '600x600'
        }

        if (windowWidth >= 768 && windowWidth <= 1280) {
            productsRequiredForCarousel = 3
        }

        if (windowWidth >= 1280 && windowWidth <= 1600) {
            productsRequiredForCarousel = 4
        }

        if (windowWidth >= 1600) {
            productsRequiredForCarousel = 6
        }

        if (productCount < productsRequiredForCarousel) {
            imageSize = '600x600'
        }

        // Construct the template
        for (let handle in theme.recentlyViewed.recent) {

            let context = theme.recentlyViewed.recent[handle]

            if (context.featured_image) {
                context.imageSrc = context.featured_image.replace('.jpg', '_' + imageSize + '.jpg')
            }

            if (productCount < productsRequiredForCarousel) {
                context.noCarousel = true
            }

            // Compile the template
            let instance = Handlebars.compile(template)
            let output = instance(context)
            $('#recently__viewed').append(output)

        }
        
        $('.collection-carousel').removeClass('hidden')
        $('[data-recently-viewed]').removeClass('hidden')

        if (productCount >= productsRequiredForCarousel) {
        
            // Initialise the carousel
            SureifyCarousel('.glide-recently-viewed-carousel')
        
        } else {
            
            // Hide the controls
            // $('.glide-recently-viewed-carousel').addClass('container max-w-5xl')
            $('.glide-recently-viewed-carousel-controls').addClass('hidden')

        }

    },

    isStorageSupported: function(type) {
        
        // Return false if we are in an iframe without access to sessionStorage
        if (window.self !== window.top) {
            return false;
        }
    
        var testKey = 'test';
        var storage;
        
        if (type === 'session') {
            storage = window.sessionStorage;
        }

        if (type === 'local') {
            storage = window.localStorage;
        }
    
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }

    }

};

$(function() {
    theme.recentlyViewed.boot()
})
